import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { XPlanViewer } from '../xPlanViewer/XPlanViewer';

export const ExternalAccess = () => {
    const {accessId} = useParams();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
    };

    if (submitted) {
        return <XPlanViewer username={username} password={password} sharedAccessId={accessId}/>
    }

    return (
        <div className="wrapper">
            <div className="flex flex-col items-center justify-center h-screen">
                <h1 className="text-2xl font-bold mb-4">Externer Zugriff</h1>
                <p className="mb-4">Hier können Sie auf freigegebene Inhalte zugreifen.</p>
                    <form onSubmit={handleSubmit} className="flex flex-col items-center mb-4 gap-2">
                        <input
                            type="text"
                            placeholder="Benutzername"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            className="border px-2 py-1 rounded"
                            required
                        />
                        <input
                            type="password"
                            placeholder="Passwort"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            className="border px-2 py-1 rounded"
                            required
                        />
                        <button
                            type="submit"
                            className="bg-gray-600 text-white px-4 py-2 rounded mt-4"
                        >
                            Anmelden
                        </button>
                    </form>
                <Link to="/" className="bg-gray-600 text-white px-4 py-2 rounded mt-4">Zurück zur Startseite</Link>
            </div>
        </div>
    );
}